<!--
数据块
-->
<template>
  <div class="container">
    <div class="contentBox">
      <div class="box" @click="toData('isCompleted')">
        <!--已完成评估-->
        <a-statistic :value="form.hasEvaluate" :value-style="{ color: '#fff' }" />
        <div class="title">{{ $t('home.assessment_completed') }}</div>
      </div>
      <div class="border"></div>
      <div class="box" @click="toReport('isPrint')">
        <!--报告已打印-->
        <a-statistic :value="form.hasPrint" :value-style="{ color: '#fff' }" />
        <div class="title">{{ $t('home.report_printed') }}</div>
      </div>
      <div class="border"></div>
      <div class="box" @click="toData('notCompleted')">
        <!--未完成评估-->
        <a-statistic :value="form.notEvaluate" :value-style="{ color: '#fff' }" />
        <div class="title">{{ $t('home.incomplete_assessment') }}</div>
      </div>
      <div class="border"></div>
      <div class="box" @click="toReport('notPrint')">
        <!--报告未打印-->
        <a-statistic :value="form.notPrint" :value-style="{ color: '#fff' }" />
        <div class="title">{{ $t('home.report_not_printed') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PanelLarge',
  components: {},
  props: {

  },
  data () {
    return {
      form: {}
    }
  },
  watch: {

  },
  mounted () {
    this.getChartData()
  },

  methods: {
    getChartData () {
      this.$get('web/chartData/getEvaluationData').then((r) => {
        let data = r.data
        if (data.code === 200) {
          if (data.data) {
            this.form = data.data
          }
          this.$forceUpdate()
        } else {
          this.$message.error(data.message)
        }
      })
    },
    toData (e) {
      this.$router.push(`/manage/data?key=` + e)
    },
    toReport (e) {
      this.$router.push(`/manage/report?key=` + e)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 110px;
  background: #0897E3 url('../../../../../static/img/bg1.png') no-repeat center;
  background-size: 100%;
  border-radius: 8px;
  // padding: 20px;
//   background-attachment: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contentBox {
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 20px 40px;
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
    .value {
    font-size: 24px;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: 0em;
  }
  .title {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
    margin-top: 10px;
    color: #F5F5F5;
  }
  }
  .border {
    width: 2px;
    height: 32px;
    background: #fff;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/manage/home/components/PanelLarge.vue